import { RemoveYear, hasInErrorReason } from "./helpers.js";
class LifePaymentSearchImpl {
    constructor() {
        this.format = (response) => {
            if (!response || typeof response !== "object")
                return { claimsPaymentSearch: [], searchResultMetadata: {} };
            const { searchResultMetaData, claims: rawClaims } = response;
            const claims = rawClaims;
            const { startIndex, totalResults, itemsPerPage, resultMetaData } = searchResultMetaData || {};
            const { timeTaken, _links } = resultMetaData || {};
            const searchResultMetadata = {
                startIndex,
                totalResults,
                itemsPerPage,
                timeTaken,
                links: _links,
            };
            if (!Array.isArray(claims))
                return { claimsPaymentSearch: [], searchResultMetadata };
            const claimsPaymentSearch = claims.flatMap((claim) => {
                if (hasInErrorReason(claim.claimProcessingStage, claim.customClaimStatusReason, claim.claimStatusReason, claim.claimStatusReasonDesc, claim.claimStatusReasonCdDesc, claim.customClaimStatusReasonCdDesc)) {
                    return [];
                }
                const { claimantDisplayName, claimantFirstName, claimantLastName, employeeId, taxIdentificationNumber, groupAgreementId, divisionId, eligibilityGroup, claimCoverageTypeCd, claimId, eliminationPeriodEndDate, aliasClaimId, choiceCd, disabilityBeginDt, employeeWorkStateCd, benefitBeginDt, benefitResumeDt, incurredDt, sicCd, claimReceivedTs, dateOfDeath, causeOfDeath, divisionName, claimStatusReason, claimStatusEffectiveDt, retireeInd, customCoverageDesc, payments = [], insuredDetails = {}, claimSubmissionSource, } = claim;
                const claimData = {
                    claimantDisplayName: claimantDisplayName,
                    claimantLastname: claimantLastName,
                    claimantFirstname: claimantFirstName,
                    employeeId: employeeId,
                    taxIdentificationNumber,
                    groupAgreementId,
                    divisionId,
                    divisionName,
                    eligibilityGroup,
                    coverageType: claimCoverageTypeCd,
                    claimId,
                    eliminationPeriodEndDate,
                    legacyClaimNumber: aliasClaimId,
                    choiceCd: choiceCd,
                    disabilityBeginDt: RemoveYear(disabilityBeginDt),
                    workState: employeeWorkStateCd,
                    benefitResumeDt: benefitResumeDt,
                    claimBenefitBeginDt: benefitBeginDt,
                    incurredDt: incurredDt,
                    sicCd: sicCd,
                    dateOfDeath: dateOfDeath,
                    causeOfDeath: causeOfDeath,
                    customClaimStatusReason: claimStatusReason,
                    statusEffectiveDt: claimStatusEffectiveDt,
                    receivedDt: claimReceivedTs,
                    retireeInd,
                    claimSubmissionSource: claimSubmissionSource
                };
                if (!Array.isArray(payments) || payments.length === 0)
                    return claimData;
                return payments.flatMap((payment) => {
                    const { payeeType, checkNumber, paymentAmt, paymentIssueDt, paymentPeriodBeginDt, paymentPeriodEndDt, paymentStatus, nonPayableBeginDt, nonPayableEndDt, paymentTransmitMethod, payeeFirstName, payeeFullName, payeeLastName, paymentCoverageDetails = [], claimPaymentSummary = {}, } = payment;
                    const { lastName: insuredLastName, firstName: insuredFirstName, insuredDisplayName, genderAtBirth: insuredGender, insuredRelationshipDesc, dateOfBirth: insuredDateOfBirth, postalAddresses: insuredPostalAddresses = [], } = insuredDetails || {};
                    const hasInsuredDetails = insuredDetails && Object.keys(insuredDetails).length > 0;
                    const finalInsuredLastName = hasInsuredDetails ? insuredLastName : claimantLastName;
                    const finalInsuredFirstName = hasInsuredDetails ? insuredFirstName : claimantFirstName;
                    const finalInsuredDisplayName = hasInsuredDetails ? insuredDisplayName : claimantDisplayName;
                    const insuredPrimaryAddress = insuredPostalAddresses?.[0] || {};
                    const { employeeSocialSecurityTaxAmt, federdalWithHoldingTaxAmt, stateWithHoldingTaxAmt, socialSecurityOffsetAmt, grossBenefitAmt, localWithHoldingTaxAmt, stateOffsetAmt, dentalInsurancePremiumAmt, overReductionPaymentAmt, postTaxTotalAmt, preTaxMedicalInsTotalAmt, preTaxTotalAmt, workersCompensationOffsetAmt, allOtherOffsetAmt, employerSocialSecurityTaxAmt, medicareTaxAmt, } = claimPaymentSummary;
                    const coverageDetails = paymentCoverageDetails.length > 0
                        ? paymentCoverageDetails
                        : [{}];
                    return coverageDetails.flatMap((coverageDetail) => {
                        const { coverageProductType, basicInsuredPaidAmt, basicInterestPaidAmt, supplementalInsuredPaidAmt, supplementalInterestPaidAmt, basicInsuredPendingAmt, supplementalInsuredPendingAmt, totalInsuredPendingAmt, totalInsuredPaidAmt, } = coverageDetail;
                        return {
                            ...claimData,
                            coverageSourceDesc: coverageProductType,
                            payeeType: payeeType,
                            employeeSSTax: employeeSocialSecurityTaxAmt,
                            federalWithholding: federdalWithHoldingTaxAmt,
                            stateWithholding: stateWithHoldingTaxAmt,
                            checkEftNumber: checkNumber,
                            paymentAmount: paymentAmt,
                            paymentDate: paymentIssueDt,
                            paymentStartDate: paymentPeriodBeginDt,
                            paymentEndDate: paymentPeriodEndDt,
                            paymentStatus: paymentStatus,
                            socialSecurityOffsetAmt: socialSecurityOffsetAmt,
                            grossBenefitInPeriod: grossBenefitAmt,
                            nonPaymentStartDt: nonPayableBeginDt,
                            nonPaymentEndDt: nonPayableEndDt,
                            localWithholding: localWithHoldingTaxAmt,
                            stateOffsetAmt: stateOffsetAmt,
                            dentalInsurancePremiumAmt: dentalInsurancePremiumAmt,
                            overpaymentReduction: overReductionPaymentAmt,
                            postTaxTotal: postTaxTotalAmt,
                            preTaxMedicalInsurance: preTaxMedicalInsTotalAmt,
                            preTaxTotal: preTaxTotalAmt,
                            paymentType: paymentTransmitMethod,
                            wcOffset: workersCompensationOffsetAmt,
                            otherOffsetsAmt: allOtherOffsetAmt,
                            employerSSTax: employerSocialSecurityTaxAmt,
                            medicareTax: medicareTaxAmt,
                            paymentGrossBenefitAmt: grossBenefitAmt,
                            payeeFirstName: payeeFirstName,
                            payeeLastName: payeeLastName,
                            payeeFullName: payeeFullName,
                            coverageProductType: coverageProductType,
                            paymentsBasicInsuredPaidAmt: basicInsuredPaidAmt,
                            paymentsBasicInterestPaidAmt: basicInterestPaidAmt,
                            supplementalInsuredPaidAmt: supplementalInsuredPaidAmt,
                            supplementalInterestPaidAmt: supplementalInterestPaidAmt,
                            paymentsBasicInsuredPendingAmt: basicInsuredPendingAmt,
                            supplementalInsuredPendingAmt: supplementalInsuredPendingAmt,
                            totalInsuredPendingAmt: totalInsuredPendingAmt,
                            totalInsuredPaidAmt: totalInsuredPaidAmt,
                            dateOfBirth: insuredDateOfBirth,
                            lastName: finalInsuredLastName,
                            firstName: finalInsuredFirstName,
                            fullName: finalInsuredDisplayName,
                            postalCode: insuredPrimaryAddress.postalCd,
                            city: insuredPrimaryAddress.city,
                            addressLineOne: insuredPrimaryAddress.addressLineOne,
                            addressLineTwo: insuredPrimaryAddress.addressLineTwo,
                            genderAtBirth: insuredGender,
                            insuredRelationshipDesc: !insuredRelationshipDesc?.trim() ? 'Self' : insuredRelationshipDesc,
                            insuredLastName: finalInsuredLastName,
                            insuredFirstName: finalInsuredFirstName,
                            insuredDisplayName: finalInsuredDisplayName,
                            insuredGender: insuredGender,
                            insuredPostalAddresses: insuredPostalAddresses,
                            insuredAddressLineOne: insuredPrimaryAddress.addressLineOne,
                            insuredAddressLineTwo: insuredPrimaryAddress.addressLineTwo,
                            insuredAddressLineThree: insuredPrimaryAddress.addressLineThree,
                            insuredCity: insuredPrimaryAddress.city,
                            insuredJurisdictionCode: insuredPrimaryAddress.jurisdictionCode,
                            insuredPostalCode: insuredPrimaryAddress.postalCd,
                            insuredAddressTypeCd: insuredPrimaryAddress.addressTypeCd,
                            insuredDateOfBirth: insuredDateOfBirth,
                        };
                    });
                });
            });
            return { claimsPaymentSearch, searchResultMetadata };
        };
    }
}
export const LifePaymentSearch = new LifePaymentSearchImpl();
